import { Directive, ElementRef, Input } from "@angular/core";
import { ɵNzTabNavItemDirective } from "ng-zorro-antd/tabs";
import { UiTabComponent } from "../tab.component";

@Directive({
  selector: "[uiTabNavItem]",
})
export class UiTabNavItemDirective extends ɵNzTabNavItemDirective {
  @Input() public disabled = false;
  @Input() public tab!: UiTabComponent;
  @Input() public active = false;

  constructor(public elementRef: ElementRef<HTMLElement>) {
    super(elementRef);
  }

  public focus(): void {
    // the parent element is the one with the role="tab"
    this.elementRef.nativeElement.parentElement.focus();
  }
}
